import React from 'react'
import PropTypes from 'prop-types'
import { lightBlue900 as TitleColor } from 'material-ui/styles/colors'

import { createStyleSheet } from 'jss-theme-reactor'
const styleSheet = createStyleSheet('VisitDetailsRow', theme => {
  return {
    title: {
      paddingTop: '5px',
      paddingLeft: '15px',
      color: TitleColor,
      fontSize: '90%',
    },
    child: {
      paddingBottom: '5px',
    },
    container: {
      border: '1px solid #efefef',
    },
  }
})

export const VisitDetailsRow = (
  { label, children, height = '60px' },
  context
) => {
  const classes = context.styleManager.render(styleSheet)

  return (
    <div className={classes.container} style={{ maxHeight: height }}>
      <div className={classes.title}>{label}</div>
      <div className={classes.child}>{children}</div>
    </div>
  )
}

VisitDetailsRow.contextTypes = {
  styleManager: PropTypes.object.isRequired,
}

VisitDetailsRow.propTypes = {
  label: PropTypes.string,
  height: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}
